const XHTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
const HEADER_HEIGHT = 56;

const slugify = text =>
  String(text)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();

  // Revoking straight away can cancel the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// The SVG snapshot can't see the page's stylesheets, so resolved styles are copied inline.
const cloneWithStyles = source => {
  if (source.dataset && source.dataset.exportIgnore !== undefined) {
    return null;
  }

  const computed = window.getComputedStyle(source);

  if (source instanceof HTMLCanvasElement) {
    const image = document.createElement('img');

    image.src = source.toDataURL('image/png');
    image.style.width = computed.width;
    image.style.height = computed.height;

    return image;
  }

  const clone = source.cloneNode(false);

  clone.setAttribute(
    'style',
    Array.from(computed)
      .map(property => `${property}:${computed.getPropertyValue(property)};`)
      .join('')
  );

  source.childNodes.forEach(child => {
    if (child.nodeType === Node.ELEMENT_NODE) {
      const childClone = cloneWithStyles(child);

      if (childClone) {
        clone.appendChild(childClone);
      }
    } else if (child.nodeType === Node.TEXT_NODE) {
      clone.appendChild(child.cloneNode(true));
    }
  });

  return clone;
};

const loadImage = src =>
  new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Unable to render the metric.'));
    image.src = src;
  });

const snapshot = (element, width, height) => {
  const clone = cloneWithStyles(element);

  clone.setAttribute('xmlns', XHTML_NAMESPACE);

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}"><foreignObject width="100%" height="100%">${new XMLSerializer().serializeToString(
    clone
  )}</foreignObject></svg>`;

  return loadImage(
    `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
  );
};

const captureElementAsPng = async (element, { title, subtitle }) => {
  const scale = window.devicePixelRatio || 1;
  const { width, height } = element.getBoundingClientRect();

  const image = await snapshot(element, width, height);

  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(width * scale);
  canvas.height = Math.ceil((height + HEADER_HEIGHT) * scale);

  const context = canvas.getContext('2d');
  context.scale(scale, scale);

  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, width, height + HEADER_HEIGHT);

  context.fillStyle = '#111827';
  context.font = '600 16px sans-serif';
  context.fillText(title, 16, 24);

  context.fillStyle = '#4b5563';
  context.font = '12px sans-serif';
  context.fillText(subtitle, 16, 44);

  context.drawImage(image, 0, HEADER_HEIGHT, width, height);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob =>
        blob ? resolve(blob) : reject(new Error('Unable to create the image.')),
      'image/png'
    );
  });
};

export { slugify, saveBlob, captureElementAsPng };
